import { useEffect, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { useQueryResponseLoading } from "../../core/QueryResponseProvider";
import { useQueryRequest } from "../../core/QueryRequestProvider";
import { RootState } from "../../../../../../../setup/redux/store";
import * as StorefrontListRedux from "../../../../../../modules/product/storefront/storefrontList/StorefrontListSlice";

const StorefrontListPagination = () => {
  const dispatch = useDispatch();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const { t } = useTranslation();
  const isLoading = useQueryResponseLoading();
  const { state, updateState } = useQueryRequest();
  const count = useSelector(
    (state: RootState) => state.StorefrontList.countStorefront
  );
  const arrayStorefrontPagination = useSelector(
    (state: RootState) => state.StorefrontList.arrayStorefrontPagination
  );
  const [value, setValue] = useState(10);
  const [page, setPage] = useState(1);
  // const [arrPagination, setArrPagination] = useState<number[]>([]);
  const [totalItems, setTotalItems] = useState(10);
  const [defItemView, setDefItemView] = useState(10);
  const [minimumPage, setMinimumPage] = useState(1);
  const [pagination, setPagination] = useState<number[]>([1, 2, 3, 4, 5, 6, 7]);
  const [currentButton, setCurrentButton] = useState<string>("1");
  // const [maxPage, setMaxPage] = useState(10)

  useEffect(() => {
    setPage(1);
  }, [totalItems]);

  useEffect(() => {
    setPage(1);
  }, [state.sort, state.search]);

  let maxPage = Math.ceil(count / state.items_per_page);
  console.log("max page ==>> " + maxPage);

  useEffect(() => {
    maxPage = Math.ceil(count / state.items_per_page);
    const numberOfPages: any = [];
    for (let i = 1; i <= maxPage; i++) {
      numberOfPages.push(i + "");
    }
    console.log("Clicked Masuk Use Effect ");

    let tempNumberOfPages: string[] = [...arrayStorefrontPagination];

    let dotsInitial = "...";
    let dotsLeft = "... ";
    let dotsRight = " ...";

    if (numberOfPages.length < 6) {
      // [1,2,3,4,5,6]
      tempNumberOfPages = numberOfPages;
      console.log("Clicked Masuk if 1 ");
      MovePage(parseInt(currentButton));
    } else if (currentButton === dotsInitial) {
      //Action Selected Dot Initial
      console.log("Clicked Masuk if 2 ");
      // [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // arrOfCurrButtons[3] = 4 + 1 = 5
      // or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      const value =
        parseInt(arrayStorefrontPagination[arrayStorefrontPagination.length - 3]) + 1;
      setCurrentButton(value + "");
      MovePage(value);
    } else if (currentButton === dotsRight) {
      //Action Selected Dot Right
      console.log("Clicked Masuk if 3 ");
      const value = parseInt(arrayStorefrontPagination[3]) + 2;
      setCurrentButton(value + "");
      MovePage(value);
    } else if (currentButton === dotsLeft) {
      //Action Selected Dot Left
      console.log("Clicked Masuk if 4 ");
      const value = parseInt(arrayStorefrontPagination[3]) - 2;
      setCurrentButton(value + "");
      MovePage(value);
    } else if (parseInt(currentButton) >= 1 && parseInt(currentButton) <= 3) {
      //[1, 2, 3, 4, "...", 10]
      console.log("Clicked Masuk if 5 ");
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
      MovePage(parseInt(currentButton));
    }
    // else if (parseInt(currentButton)  === 4) {//[1, 2, 3, 4, 5"...", 10]
    //   const sliced = numberOfPages.slice(0, 5);
    //   tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    //   MovePage(parseInt(currentButton));
    // }
    else if (
      parseInt(currentButton) >= 4 &&
      parseInt(currentButton) < numberOfPages.length - 2
    ) {
      console.log("Clicked Masuk if 6 ");
      // from 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(
        parseInt(currentButton) - 2,
        parseInt(currentButton)
      ); // sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(
        parseInt(currentButton),
        parseInt(currentButton) + 1
      ); // sliced1 (5, 5+1) -> [6]
      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
      MovePage(parseInt(currentButton));
    } else if (parseInt(currentButton) > numberOfPages.length - 3) {
      // > 7  // [1, '...', 6, 7, 8, 9, 10]
      console.log("Clicked Masuk if 7 ");
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
      tempNumberOfPages = [1, dotsLeft, ...sliced];
      MovePage(parseInt(currentButton));
    }
    dispatch(StorefrontListRedux.setArrayStorefrontPagination(tempNumberOfPages));
  }, [currentButton, count]);

  const updateTotalItem = (totalItem: number) => {
    setTotalItems(totalItem);
    if (count / totalItem <= 6) {
      let arr: string[] = [];
      console.log(
        "--->> Array round : " +
          count +
          " / " +
          totalItem +
          " = " +
          Math.ceil(count / totalItem) +
          " (" +
          count / totalItem +
          ")"
      );
      for (let index = 1; index <= Math.ceil(count / totalItem); index++) {
        arr.push(index + "");
      }
      console.log("--->> Array Index : " + arr);
      dispatch(StorefrontListRedux.setArrayStorefrontPagination(arr));
    } else {
      dispatch(
        StorefrontListRedux.setArrayStorefrontPagination([
          "1",
          "2",
          "3",
          "4",
          "...",
          Math.ceil(count / totalItem) + "",
        ])
      );
    }
    updateState({ items_per_page: totalItem, action: "noAction", page: 1 });
  };

  const PrevItemPage = () => {
    if (page <= 1) {
      return;
    }
    let pages = page - 1;
    setCurrentButton(pages + "");
    setPage(pages);
    updateState({ action: "prev", page: page, items_per_page: totalItems });
  };

  const NextItemPage = () => {
    if (page >= maxPage) {
      return;
    } else {
      let pages = page + 1;
      setCurrentButton(pages + "");
      setPage(pages);
      updateState({ action: "next", page: page, items_per_page: totalItems });
    }
  };

  const MovePage = (pageTo: number) => {
    setPage(pageTo);
    updateState({ page: pageTo, items_per_page: totalItems });
  };

  const updateCurrentButton = (index: string) => {
    console.log("Clicked Button :" + index);
    setCurrentButton(index);
  };

  return (
    <div
      className={clsx({
        "row align-items-center justify-content-center py-5": !isTabletOrMobile,
        "p-5 d-flex align-items-center justify-content-between": isTabletOrMobile,
      })}
    >
      <div
        className={clsx({
          "col-4 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start":
            !isTabletOrMobile,
            "pb-3": isTabletOrMobile
        })}
      >
        <div
          v-if="enableItemsPerPageDropdown"
          className="dataTables_length flex-left"
          id="kt_customers_table_length"
          data-testid="pagination"
        >
          <label>
            <select
              name="kt_customers_table_length"
              className="form-select form-select-sm form-select-solid"
              defaultValue={defItemView}
              onChange={(e) => {
                const selectedValue = e.target.value;
                updateTotalItem(parseInt(selectedValue));
                setCurrentButton("1");
              }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
              <option value={60}>60</option>
              <option value={70}>70</option>
              <option value={80}>80</option>
              <option value={90}>90</option>
              <option value={100}>100</option>
            </select>
          </label>
        </div>
      </div>
      <div
        className={clsx({
          "my-0 py-0 col-8 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end":
            !isTabletOrMobile,
        })}
      >
        <div id="kt_table_users_paginate">
          <ul className="pagination">
            {/* Button Previous */}
            {page <= 1 ? (
              <li className="my-0 py-0 page-item disabled">
                <a className="my-0 py-0 page-link " style={{ cursor: "pointer" }}>
                  {isTabletOrMobile ? (
                    <span>«</span>
                  ) : (
                    <span>« {t("Contacts.Pages.Previous")}</span>
                  )}
                </a>
              </li>
            ) : (
              <li className="my-0 py-0 page-item ">
                <a
                  className="my-0 py-0 page-link "
                  style={{ cursor: "pointer" }}
                  onClick={PrevItemPage}
                >
                  {isTabletOrMobile ? (
                    <span>«</span>
                  ) : (
                    <span>« {t("Contacts.Pages.Previous")}</span>
                  )}
                </a>
              </li>
            )}
            {/* End Of Button Previous */}

            {/* Number Button */}
            {arrayStorefrontPagination.map((i) => {
              if (i == page + "") {
                return (
                  <li key={i} className="my-0 py-0 page-item active">
                    <p
                      className={clsx("my-0 py-0 page-link", {
                        "me-3": !isTabletOrMobile,
                      })}
                      key={i}
                      onClick={() => setCurrentButton(i)}
                    >
                      {i}
                    </p>
                  </li>
                );
              }
              return (
                <li key={i} className="my-0 py-0 page-item">
                  <a
                    className={clsx("my-0 py-0 page-link", { "me-3": !isTabletOrMobile })}
                    style={{ cursor: "pointer" }}
                    onClick={() => updateCurrentButton(i)}
                  >
                    {i}
                  </a>
                </li>
              );
            })}
            {/* End of Number Button

            {/* Next Button */}
            {page === Math.ceil(maxPage) ? (
              <li className="my-0 py-0 page-item disabled">
                <a className="my-0 py-0 page-link " style={{ cursor: "pointer" }}>
                  {isTabletOrMobile ? (
                    <span>»</span>
                  ) : (
                    <span>{t("Contacts.Pages.Next")} »</span>
                  )}
                </a>
              </li>
            ) : (
              <li className="my-0 py-0 page-item ">
                <a
                  className="my-0 py-0 page-link "
                  style={{ cursor: "pointer" }}
                  onClick={NextItemPage}
                >
                  {isTabletOrMobile ? (
                    <span>»</span>
                  ) : (
                    <span>{t("Contacts.Pages.Next")} »</span>
                  )}
                </a>
              </li>
            )}
            {/* End Of Next Button */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export { StorefrontListPagination };
